import {
  FC, useEffect, useCallback, useState, memo,
} from 'react';
import { EmptyState } from 'shared/ui';
import { showConfirm } from 'shared/utils';
import { FeedbackListItem } from 'entities/feedback';
import { useFeedback } from '../hooks/useFeedback';
import { FeedbackTable, FeedbackDetailModal } from '../components';

import styles from './FeedbackPage.module.scss';

export const FeedbackPage: FC = memo(() => {
  const {
    feedbacks,
    loadFeedbacks,
    deleteFeedbackById,
  } = useFeedback();

  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedFeedbackId, setSelectedFeedbackId] = useState<number | null>(null);

  useEffect(() => {
    loadFeedbacks();
  }, []);

  const handleView = useCallback((feedback: FeedbackListItem) => {
    if (feedback.id) {
      setSelectedFeedbackId(feedback.id);
      setIsDetailModalOpen(true);
    }
  }, []);

  const handleCloseDetailModal = useCallback(() => {
    setIsDetailModalOpen(false);
    setSelectedFeedbackId(null);
  }, []);

  const handleDelete = useCallback(async (id: number) => {
    showConfirm({
      title: 'Вы уверены, что хотите удалить этот отзыв?',
      onOk: () => {
        deleteFeedbackById(id);
      },
    });
  }, [deleteFeedbackById]);

  return (
    <div className={styles.feedbackPage}>
      <div className={styles.header}>
        <h1>Отзывы</h1>
      </div>

      {feedbacks.length === 0 ? (
        <EmptyState
          message="Отзывы не найдены"
          icon="💬"
          description="Пользователи пока не оставляли отзывы."
        />
      ) : (
        <FeedbackTable
          feedbacks={feedbacks}
          onDelete={handleDelete}
          onView={handleView}
        />
      )}

      {isDetailModalOpen && (
        <FeedbackDetailModal
          feedbackId={selectedFeedbackId}
          onClose={handleCloseDetailModal}
        />
      )}
    </div>
  );
});

FeedbackPage.displayName = 'FeedbackPage';
